import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgDbIcDay24 = (props) => /* @__PURE__ */ _jsx("svg", {
	id: "icon",
	height: 24,
	viewBox: "0 0 24 24",
	width: 24,
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "m12 18a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0v-2a1 1 0 0 1 1-1zm5.657-1.757 1.414 1.414a1 1 0 0 1 -1.414 1.414l-1.414-1.414a1 1 0 1 1 1.414-1.414zm-9.9 0a1 1 0 0 1 0 1.414l-1.414 1.413a1 1 0 1 1 -1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0zm4.243-8.243a4 4 0 1 1 0 8 4 4 0 0 1 0-8zm0 2a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm9 1a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2zm-16 0a1 1 0 0 1 0 2h-2a1 1 0 0 1 0-2zm1.343-6.071 1.414 1.414a1 1 0 0 1 -1.414 1.414l-1.413-1.414a1 1 0 0 1 1.413-1.413zm12.728 0a1 1 0 0 1 0 1.414l-1.414 1.414a1 1 0 1 1 -1.414-1.414l1.414-1.414a1 1 0 0 1 1.414 0zm-7.071-2.929a1 1 0 0 1 1 1v2a1 1 0 0 1 -2 0v-2a1 1 0 0 1 1-1z",
		fill: "var(--db-icon-color, currentColor)",
		fillRule: "evenodd"
	})
});
export default SvgDbIcDay24;
